export default __webpack_public_path__ + "static/media/ThreeStar.fa8b1249.svg";